// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"71166441","977":"ef296c18"}[chunkId] + ".chunk.js";
};